export const Lightboxes = {
    Subscriptions: 0,
    AdminUserProfile: 1,
    Agreements: 2,
    Expired: 3,
    UserProfileEdit: 4
};
